import React from "react";
// COMPONENTS
import MonitoringGrid from "./MonitoringGrid";
import MonitoringHeader from "./MonitoringHeader";
import BanksDrawer from "../../edgeManagement/banks/BanksDrawer";
import MonitoringModalSaveNewGrid from "./MonitoringModalSaveNewGrid";
import MonitoringModalManageGrids from "./MonitoringModalManageGrids";
import MonitoringSelectFirstGrid from "./MonitoringSelectFirstGrid";
import AuthenticationTOTP from "../../authentication/AuthenticationTOTP";
import ControlPanelLift from "../ControlPanel/ControlPanelLift";
import ControlPanelBank from "../ControlPanelBank/ControlPanelBank";
// MONITORING CONTEXT
import { BankMessagesProvider } from "../socketMessageState/BankMessagesContext";
import { SequenceRunsProvider } from "../sequenceRuns/SequenceRunsContext";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";

const MonitoringPage = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  // Reads SCREEN_PERMISSION["monitoring"] -- the same declaration Layout.tsx's
  // sidebar link reads.
  const allowed = useScreenPermission("monitoring");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <BankMessagesProvider>
      <SequenceRunsProvider>
        <div>
          {allowed ? (
            <div>
              {
                // userLogged &&
                // userLogged.prefGridId &&
                // userLogged.prefGridId !== "" &&
                // userLogged.prefGridId !== "00000000-0000-0000-0000-000000000000" ? (
                // eslint-disable-next-line no-constant-condition
                true ? (
                  <>
                    <MonitoringHeader />
                    <MonitoringGrid />
                    <BanksDrawer />
                    <MonitoringModalSaveNewGrid />
                    <MonitoringModalManageGrids />
                    <AuthenticationTOTP />
                    <ControlPanelLift />
                    <ControlPanelBank />
                  </>
                ) : (
                  <MonitoringSelectFirstGrid />
                )
              }
            </div>
          ) : (
            <UnauthorizedPage />
          )}
        </div>
      </SequenceRunsProvider>
    </BankMessagesProvider>
  );
};

export default MonitoringPage;
